<p-button
  [type]="type()"
  [icon]="icon() || undefined"
  [iconPos]="iconPos()"
  [loading]="loading()"
  [loadingIcon]="loadingIcon() || undefined"
  [disabled]="disabled()"
  [severity]="normalizedSeverity()"
  [text]="text()"
  [rounded]="rounded()"
  [outlined]="outlined()"
  [plain]="plain()"
  [raised]="raised()"
  [size]="size() || undefined"
  [attr.title]="title() || null"
  [badge]="badge() || undefined"
  [badgeSeverity]="normalizedBadgeSeverity()"
  [styleClass]="styleClass()"
  [label]="(value() || label()) || undefined"
  (onClick)="handleClick($event)"
  (click)="handleClick($event)">
</p-button>
